import { render, staticRenderFns } from "./MarketLogDialog.vue?vue&type=template&id=383f0ca9&scoped=true"
import script from "./MarketLogDialog.vue?vue&type=script&lang=js"
export * from "./MarketLogDialog.vue?vue&type=script&lang=js"
import style0 from "./MarketLogDialog.vue?vue&type=style&index=0&id=383f0ca9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383f0ca9",
  null
  
)

export default component.exports